var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('lunbo'),_c('div',{staticStyle:{"width":"100%","background":"#fff","padding":"0px 24px","margin-bottom":"20px"}},[_c('information'),_c('nominating'),_c('award')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }